'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'sword';
var width = 576;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = 'M171.4 276.7l292.7-292.7 96 0 0 96-292.7 292.7c31.5 31.5 48.6 48.6 51.3 51.3l-27.3 27.3-6.3 6.3-8.6-2-95.4-22-45 45 0 32-4.7 4.7c-18.1 18.1-29.9 29.9-35.3 35.3l-11.3-11.3-80-80-11.3-11.3c5.4-5.4 17.2-17.2 35.3-35.3l4.7-4.7 32 0 45-45-22-95.4-2-8.6c6.9-6.9 32.7-32.7 33.6-33.6 2.8 2.8 19.9 19.9 51.3 51.3zm22.6 22.6l50.7 50.7 283.3-283.3 0-50.7-50.7 0-283.3 283.3zm-50.3 65.1l2 8.6-6.3 6.3-56 56-4.7 4.7-32 0-8 8 57.4 57.4 8-8 0-32 4.7-4.7 56-56 6.3-6.3 8.6 2 91.2 21.1-148.3-148.3 21.1 91.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;